// FT-183: гейт маршрутов разделов, скрытых для типа техники компании (штрафы,
// страховки ТС, настройки агрегатора у вело-компании). Вынесен из router/index.js
// отдельным модулем по той же причине, что и staffGate: импорт роутера в спеках
// ломает чужие спеки (см. шапку router/staffGate.js).
//
// Компании в сторе нет или тип не пришёл — пропуск (fail-open). Гидрация
// vuex-persist синхронна, так что в живых сценариях тип известен; разрыв (поздняя
// загрузка, смена филиала на открытой странице) закрывает гейт страницы —
// mixins/rentalObjectSectionGuard. Это интерфейс, а не защита данных: API раздела
// не меняется.
import { routeVisible, companyRentalObject } from "@/utils/rentalObjectFeatures";

// Возвращает аргумент для next() — либо undefined, если маршрут пропускаем.
export function rentalObjectGateRedirect(path, companyWrapper) {
  return routeVisible(companyRentalObject(companyWrapper), path) ? undefined : { name: "Home" };
}
